import { Reveal } from "@/components/Reveal";
import { METODOLOGIA } from "@/data/content";

export const Metodologia = () => {
  return (
    <section
      id="metodologia"
      data-testid="metodologia-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal className="max-w-3xl">
          <p className="text-sm font-medium text-[#E60000] tracking-[0.2em] uppercase mb-6">
            {METODOLOGIA.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] leading-tight">
            {METODOLOGIA.title}
          </h2>
          <p className="text-lg font-light text-[#525252] leading-relaxed mt-8">
            {METODOLOGIA.description}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-20">
          {METODOLOGIA.stages.map((stage, i) => (
            <Reveal
              key={stage.number}
              delay={(i % 2) * 0.12}
              className="group relative bg-white border border-[#E5E5E5] p-8 md:p-12 transition-all duration-500 hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.12)] hover:-translate-y-1.5 hover:border-[#E60000]"
              testId={`metodologia-card-${i}`}
            >
              <span className="absolute left-0 top-0 h-1 w-0 bg-[#E60000] group-hover:w-full transition-all duration-500" />
              <div className="flex items-start gap-6">
                <span className="text-4xl md:text-5xl font-black text-[#E60000] tracking-tighter shrink-0 group-hover:scale-110 transition-transform duration-500 origin-left">
                  {stage.number}
                </span>
                <div>
                  <h3 className="text-xl md:text-2xl font-semibold tracking-tight text-[#0A0A0A] mb-4">
                    {stage.title}
                  </h3>
                  <p className="text-[#525252] leading-relaxed">{stage.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Metodologia;
